import { filterOrganizationTreeItems, filterOrganizationsForUser, } from '../../../../backend/features/organizations/shared';
import { useContactManagementTranslation, useUserState } from '../../../../ui/hooks';
import { useDataTreeUsingUrl, } from '@juvare/common-data-table-ui/DataTree';
import cloneDeep from 'lodash.clonedeep';
import React from 'react';
import { filterOrganizationTreeItemsByFieldFilter } from '../components/OrganizationsPanel/utils/filterOrganizationTreeItemsByFieldFilter';
import { makeUniqueIds } from '../components/OrganizationsPanel/utils/makeUniqueIds';
import { selectInitialOrgs } from '../components/OrganizationsPanel/utils/selectInitialOrgs';
import { mapOrganizationFilterData } from './useOrganizationsTree';
export function useOrganizationSelectionTree({ useDataTreeFunction = useDataTreeUsingUrl, filteredOrganizationsIds, initialSelectedOrganizationIds, includeVisible, includeByMembership, includeByOrgPermission, includeRootDirectory, }) {
    var _a;
    const userState = useUserState();
    // Need to make sure that there are no duplicate id's in any row, otherwise DataTree can get confused
    const organizations = userState.organizations;
    const orgs = cloneDeep(organizations);
    makeUniqueIds(orgs);
    const { t } = useContactManagementTranslation();
    const params = {
        useDataProvider: (request) => {
            const data = React.useMemo(() => {
                const filteredOrganizations = filterOrganizationsForUser(orgs, includeVisible !== null && includeVisible !== void 0 ? includeVisible : false, includeByMembership !== null && includeByMembership !== void 0 ? includeByMembership : false, includeByOrgPermission, userState);
                const selectedOrganizations = filterOrganizationTreeItems(filteredOrganizations, (item) => {
                    if (filteredOrganizationsIds) {
                        return filteredOrganizationsIds === null || filteredOrganizationsIds === void 0 ? void 0 : filteredOrganizationsIds.includes(item.id.split('_')[0]);
                    }
                    return true;
                });
                // Apply any filters
                const filterResult = filterOrganizationTreeItemsByFieldFilter(selectedOrganizations, mapOrganizationFilterData({ search: request.filterData.search }), userState);
                const organizations = includeRootDirectory
                    ? [
                        {
                            id: 'root',
                            name: t('panels.organizations.root'),
                            children: filterResult.organizations,
                            visible: false,
                            path: t('panels.organizations.root'),
                        },
                    ]
                    : filterResult.organizations;
                return {
                    items: organizations,
                    highlightedItemIds: filterResult.highlightedOrganizationIds.length > 0 ? filterResult.highlightedOrganizationIds : undefined,
                };
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [request.filterData.search, filteredOrganizationsIds, initialSelectedOrganizationIds]);
            return {
                data,
                error: undefined,
                reload: () => undefined,
                isLoading: false,
            };
        },
    };
    const { dataTreeProps, filtersBarProps, appliedFilterData, reload } = useDataTreeFunction(Object.assign(Object.assign({}, params), { initialSelectedItemIds: selectInitialOrgs(initialSelectedOrganizationIds !== null && initialSelectedOrganizationIds !== void 0 ? initialSelectedOrganizationIds : [], orgs) }));
    const defaultDataTreeProps = Object.assign(Object.assign({}, dataTreeProps), { 'data-test': 'organization-tree' });
    const selectedOrganizationIds = React.useMemo(() => {
        var _a;
        return (_a = dataTreeProps.selectedItemIds) === null || _a === void 0 ? void 0 : _a.map((id) => id.split('_')[0]);
    }, [dataTreeProps.selectedItemIds]);
    return {
        dataTreeProps: defaultDataTreeProps,
        filtersBarProps,
        appliedFilterData,
        reload,
        activeOrganizationId: (_a = dataTreeProps.activeItemId) === null || _a === void 0 ? void 0 : _a.split('_')[0],
        selectedOrganizationIds,
    };
}
